var React = require('react');

function Attention (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M28.52.7A93.77,93.77,0,0,0,16,0,93.77,93.77,0,0,0,3.48.7,3.33,3.33,0,0,0,.7,3.48,93.77,93.77,0,0,0,0,16,93.77,93.77,0,0,0,.7,28.52,3.33,3.33,0,0,0,3.48,31.3,93.77,93.77,0,0,0,16,32a93.77,93.77,0,0,0,12.52-.7,3.33,3.33,0,0,0,2.78-2.78A93.77,93.77,0,0,0,32,16a75.06,75.06,0,0,0-.7-12.52A3.33,3.33,0,0,0,28.52.7Z","key":0}),React.createElement("path",{"fill":"white","d":"M16,7a2,2,0,0,1,2,2v8a2,2,0,0,1-4,0V9A2,2,0,0,1,16,7Zm0,19a2,2,0,1,1,2-2A2,2,0,0,1,16,26Z","key":1})]);
}

Attention.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Attention;

Attention.default = Attention;
